import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { selectCreateTask, setTaskId, setCreateTask, setTaskStatus } from 'store/economicSlice'
import { createEconomicTask } from 'services/apiRequests'
import { selectProjectID, selectTrunkPipelineID } from 'store/projectSlice'
import { setBlockingWindow } from 'store/commonSlice'
import { IErrorParams } from 'store/types'

const useCreateTask = () => {
  const dispatch = useDispatch()
  const createTask = useSelector(selectCreateTask)
  const projectId = useSelector(selectProjectID)
  const trunkPipelineId = useSelector(selectTrunkPipelineID)

  const getError = (detail: string): JSX.Element => {
    switch (true) {
      case ['Для экономического расчета', 'требуется рассчитанный гидравлический расчет'].every((substr) =>
        detail.includes(substr),
      ):
        return (
          <>
            {'Для запуска экономического расчета необходимо'} <br /> {'выполнить гидравлический расчет со статусом'}{' '}
            <br /> {'"Рассчитано"'}
          </>
        )
      case ['Гидравлический результат неактуален', 'Требуется заново выполнить гидравлический расчет'].every((substr) =>
        detail.includes(substr),
      ):
        return (
          <>
            {'Исходные данные трубопровода были изменены.'} <br /> {'Пожалуйста, перезапустите гидравлический расчет.'}
          </>
        )
      default:
        if (detail === 'Pipelines are too long. Total length of pipelines must be less than 10000km.') {
          return <>{'Общая длина трубопровода не должна превышать 10000 км.'}</>
        } else if (detail === 'Pipelines are too long. Length of each pipeline must be less than 3000km.') {
          return <>{'Длина каждого участка трубопровода не должна превышать 3000 км.'}</>
        }
        return <>{'Непредвиденная ошибка'}</>
    }
  }

  const tryToCreateTask = async () => {
    if (trunkPipelineId && projectId) {
      await createEconomicTask(projectId, trunkPipelineId)
        .then((response) => {
          dispatch(setTaskId(response.data.id))
          dispatch(setTaskStatus('Запущен'))
        })
        .catch((err) => {
          if (err.response.status === 400) {
            dispatch(
              setBlockingWindow({
                type: 'ERROR',
                params: {
                  title: 'Ошибка запуска расчета',
                  message: getError(err.response.data?.detail),
                } as IErrorParams,
              }),
            )
          } else {
            dispatch(
              setBlockingWindow({
                type: 'ERROR',
                params: { title: 'Непредвиденная ошибка', message: 'Непредвиденная ошибка' } as IErrorParams,
              }),
            )
          }
          dispatch(setCreateTask(false))
        })
    }
  }

  React.useEffect(() => {
    if (createTask) tryToCreateTask().then()
  }, [createTask])

  return
}

export default useCreateTask
